import {Component, OnInit, Input, Output, ViewChild, EventEmitter} from '@angular/core';
import { DialogRef } from '@progress/kendo-angular-dialog';
import { AutoUnsubscribe } from '../../../fw/decoractors/AutoUnsubscribe';
import {ColumnDefinition} from "../../../fw/dynamic-grids/column-definition";
import {DynamicGridComponent} from "../../../fw/dynamic-grids/dynamic-grid.component";
import {SettingsCashregService} from "./settings-cashreg.service";
import {SharedService} from "../../shared/shared.service";

@Component({
    selector: 'price-change-correction',
    template: require('./price-change-correction.component.html'),
    styles: [require('./price-change-correction.component.css')]
})
@AutoUnsubscribe()

export class PriceChangeCorrectionComponent implements OnInit {
    @Input() dialog: DialogRef;
    @Input() type: string;
    @Output() chosenId = new EventEmitter<number>();
    @Output() deletedId = new EventEmitter<number>();
    @ViewChild('grid', {static: false}) grid: DynamicGridComponent;
    columnDefinition: ColumnDefinition[] = [
        {
            key: 'changeDate',
            label: 'Datum prijswijziging',
            type: 'string',
            width: '*',
            format: '{0:dd-MM-yyyy}'
        }
    ];

    constructor(private ds: SettingsCashregService,
                private ss: SharedService) { }

    ngOnInit() {
        this.loadData();
    }

    loadData() {
        if (this.type == 'article') {
            this.ds.getFutureArticlePriceChangedPlanned().subscribe(response => {
                this.grid.showData(response);
                if (response.length == 0) {
                    this.ss.message('U heeft geen prijswijziging in de toekomst klaar staan. ' +
                        'Als u uw wijzigingen van vandaag wilt annuleren klik dan hier op sluiten en vervolgens op annuleren.');
                }
            });
        } else if (this.type == 'treatment') {
            this.ds.getFutureTreatmentPriceChangedPlanned().subscribe(response => {
                this.grid.showData(response);
                if (response.length == 0) {
                    this.ss.message('U heeft geen prijswijziging in de toekomst klaar staan. ' +
                        'Als u uw wijzigingen van vandaag wilt annuleren klik dan hier op sluiten en vervolgens op annuleren.');
                }
            });
        }
    }

    btnCloseClicked(event) {
        this.closeWindow(false);
    }

    btnEditClicked(event) {
        if (this.grid.getSelectedId() > 0) {
            this.chosenId.emit(this.grid.getSelectedId());
            this.closeWindow(true);
        }
    }

    btnDeleteClicked(event) {
        if (this.grid.getSelectedId() > 0) {
            this.ss.confirm('Weet u zeker dat u de prijswijzigingen wilt verwijderen?')
                .subscribe((res: boolean) => {
                    if (res) {
                        this.ds.deleteArticlePriceChangeById(this.grid.getSelectedId()).subscribe(res => {
                            if (res.isDeleted) {
                                this.deletedId.emit(this.grid.getSelectedId());
                                this.closeWindow(false);
                            } else
                                this.ss.message(res.infoMessage);
                        });
                    }
                });
        }
    }

    rowdoubleClicked(event) {
        this.btnEditClicked(null);
    }

    closeWindow(result: boolean) {
        if (this.dialog) {
            this.dialog.dialog.instance.action.emit(result);
            this.dialog.close();
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/settings/settings-cashreg/price-change-correction.component.ts